import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight } from "react-icons/fa6";

const NewsDetails = () => {
  const { id } = useParams(); // Get the news & events ID from the URL
  const [news, setNews] = useState([]);
  const [moreNews, setMoreNews] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate
  

  useEffect(() => {
    axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/news_events.php?id=${id}`)
      .then(response => {
        setNews(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the news and events!", error);
      });
  }, [id]); 

  useEffect(() => {
    // Fetch News & Events
    axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_news_events.php')
      .then(response => {
        setMoreNews(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the news and events!", error);
      });
  }, []);

  if (!news) {
    return ;
  }

  const handleNewsClick = (newsId) => {
    navigate(`/news-and-events/${newsId}`); // Use navigate to redirect
    setTimeout(() => {
      document.documentElement.scrollTop = 200;  // For most browsers
      document.body.scrollTop = 200;             // For older browsers / Safari
    }, 0); // Ensure scroll happens after navigation completes
  };

  // Try parsing the date, and if it fails, handle the error gracefully
  const parsedDate = new Date(news.created_date);
  const formattedDate = !isNaN(parsedDate) ? parsedDate.toLocaleDateString('default', { month: 'long', year: 'numeric' }) : 'Loading...';

  return (
    <div>
      {/* Navbar */}

        <Navbar />
      
      {/* Navbar Ending */}

      {/* Page Content starts here */}
      <section className="page-section">
        <div className="section-content">
          <p className='page-heading'>News & Events</p>

          <div className="d-none d-md-block"> {/* Visible on desktop, hidden on mobile */}
            <p className="page-subtitle">
              Stay Informed with the Latest Updated and Activities
              <br/> 
              at Caritas Matha Hospital
            </p>
          </div>

          <div className="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
            <p className="page-subtitle">
              Stay Informed with the Latest Updated and Activities at Caritas Matha Hospital
            </p>
          </div>

          <p>&nbsp;</p>
          <div className="article-details">
            <div className="article-detail-container">
              <h4>{news.title}</h4>
              <br/>
              <p>{new Date(news.created_date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</p>
              <img className='article-main-img' src={news.image_url} />
              <br/>
              <div className='article-content' dangerouslySetInnerHTML={{ __html: news.news_content }}></div>{/* Assuming article content is included */}
              <br/>
              <div className='article-more-img'>
                {news.more_image_urls &&
                  news.more_image_urls
                      .split(',')
                      .map((url, index) => (
                          <img
                              key={index}
                              src={url.trim()}  // Trim to remove any extra spaces
                          />
                      ))}
              </div>
            </div>

            <div className="more-articles">
              <h5>More News & Events</h5>

              {moreNews.map(news => (
                <div className="more-article-card">
                  <img src={news.image_url} onClick={() => handleNewsClick(news.id)}/>
                  <h6 onClick={() => handleNewsClick(news.id)}>{news.title}</h6>
                  <br/>
                  <p>{new Date(news.created_date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</p>
                </div>
              ))}
              <a href="/news-and-events" className="article-view-all">View All <FaChevronRight /></a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}

        <Footer />
      
      {/* Footer Ending */}

    </div>
  );
};

export default NewsDetails;